import {Component, Input, OnInit} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AddProgramModalComponent} from './add-program-modal/add-program-modal.component';

@Component({
  selector: 'app-add-program-button',
  templateUrl: './add-program-button.component.html',
  styleUrls: ['./add-program-button.component.css'],
  standalone: true
})
export class AddProgramButtonComponent implements OnInit {
  @Input() site_id: string;

  constructor(private modalService: NgbModal) { }

  ngOnInit(): void {
  }

  open() {
    const modalInstance = this.modalService.open(AddProgramModalComponent);
    modalInstance.componentInstance.site_id = this.site_id;
  }
}
